export default __webpack_public_path__ + "static/media/Delete.4ecd2f3e.svg";